import { getCurrentCulture } from 'owa-localize';

export function createSubjectSortCollator(): Intl.Collator {
    return new Intl.Collator(getCurrentCulture() || undefined, {
        sensitivity: 'variant',
        numeric: false,
    });
}

/**
 * Sorts rows by subject, keeping service order within equal subjects.
 *
 * @param getNormalizedSubject returns the subject with reply/forward prefixes already stripped,
 * matching the keys the Subject group headers use
 */
export default function sortRowsBySubject<T>(
    rows: readonly T[],
    getNormalizedSubject: (row: T) => string,
    descending: boolean
): T[] {
    const collator = createSubjectSortCollator();
    const direction = descending ? -1 : 1;
    return rows
        .map(row => ({ row, subject: getNormalizedSubject(row) }))
        .sort((a, b) => {
            // Headers key on exact normalized subjects, so keep distinct keys contiguous even
            // when the locale collator considers them equivalent.
            const comparison =
                collator.compare(a.subject, b.subject) ||
                (a.subject < b.subject ? -1 : a.subject > b.subject ? 1 : 0);
            return direction * comparison;
        })
        .map(({ row }) => row);
}
